export default function CTASection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Aesthetic%20boutique%20shopping%20interior%20with%20warm%20golden%20hour%20light%20streaming%20through%20window%2C%20fashion%20items%20artistically%20displayed%20on%20wooden%20shelves%2C%20modern%20European%20shop%20atmosphere%2C%20soft%20focus%20depth%2C%20inviting%20trustworthy%20ambiance%2C%20warm%20terracotta%20and%20sand%20color%20palette&width=1600&height=900&seq=kako-cta-new-02&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 text-center px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 tracking-wider mb-6">
          PRZEJDŹ DO KAKOBUY
        </h2>
        <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-xl mx-auto leading-relaxed">
          Sprawdź pełny arkusz produktów i zacznij oszczędzać na zakupach z Chin. Szybka dostawa do Polski.
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 bg-foreground-900 text-background-50 px-8 py-4 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group shadow-2xl shadow-foreground-900/30"
        >
          <span className="flex items-center justify-center w-10 h-10 rounded-full bg-accent-500 -ml-2">
            <i className="ri-shopping-bag-3-line text-background-50 text-lg"></i>
          </span>
          <span>KAKOBUY SPREADSHEET</span>
          <i className="ri-arrow-right-up-line text-background-50 text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}